import { MenuCategory } from './menu-category'

export type SelectedMenuFilterCategory = {
  name: string
  id: string
  predicate: (category: MenuCategory) => MenuCategory | null
}

export type MenuFilterCategory = {
  count: number
  filteredCount: number
} & SelectedMenuFilterCategory

// export const EVERYTHING_FILTER_CATEGORY: SelectedMenuFilterCategory = {
//   id: 'everything',
//   name: 'Everything',
//   predicate: (c) => c,
// }

export const createMenuFilterCategories = (
  menuCategories: MenuCategory[],
  categoriesWithCounts: Record<string, number>,
  { useStatsCounts = true }: { useStatsCounts?: boolean } = {},
): MenuFilterCategory[] => [
  // {
  //   ...EVERYTHING_FILTER_CATEGORY,
  //   count: categoriesWithCounts.everything ?? 0,
  // },
  ...menuCategories
    .filter(({ id }) => id !== 'everything')
    .map<MenuFilterCategory>(({ name, id, items }) => {
      const predicate = (c: MenuCategory) => (c.name === name ? c : null)
      const filteredCount = useStatsCounts
        ? (categoriesWithCounts[id] ?? categoriesWithCounts[name] ?? items.length)
        : items.length
      const count = useStatsCounts ? (categoriesWithCounts[id] ?? 0) : items.length
      return {
        name,
        id,
        predicate,
        count,
        filteredCount,
      }
    }),
  // {
  //   name: 'Hot dishes',
  //   id: 'hot_dishes',
  //   predicate: (category) => ({
  //     ...category,
  //     items: category.items.filter((i) => i.isHot),
  //   }),
  //   count: categoriesWithCounts.hot_dishes ?? 0,
  // },
  // {
  //   name: 'Cold dishes',
  //   id: 'cold_dishes',
  //   predicate: (category) => ({
  //     ...category,
  //     items: category.items.filter((i) => !i.isHot),
  //   }),
  //   count: categoriesWithCounts.cold_dishes ?? 0,
  // },
]
